import { Injectable } from '@angular/core';
import { EditDto, UseCaseController } from '@siza-staff-care/shared/data';
import { CrudService } from '@siza-staff-care/shared/global-services';
import { ICrudAdaptor } from './crud-adaptor-interface';

@Injectable({ providedIn: 'root' })
export class StandardCrudAdaptor implements ICrudAdaptor {
	constructor(private readonly crud: CrudService) {}

	open<TController = UseCaseController>(type: string, lookupTypes?: string[], opts?: TController | undefined) {
		return this.crud.open(type, lookupTypes, opts);
	}

	create(type: string, data?: Record<string, unknown> | undefined) {
		return this.crud.create(type, data);
	}

	select(type: string, oid?: string | undefined, data?: Record<string, unknown>) {
		return this.crud.select(type, oid, data);
	}

	save<TEditDto extends EditDto>(
		type: string,
		edition: number,
		oid: string,
		model: TEditDto,
		opts?: Record<string, unknown> | undefined,
	) {
		return this.crud.save(type, edition, oid, model, opts);
	}

	delete(type: string, oid: string, opts?: Record<string, unknown> | undefined) {
		return this.crud.delete(type, oid, opts);
	}
}
